export function initEntryForm() {
	const $form = jQuery('#campaign-entry-form');
	if (!$form.length) return;
	const $messages = $form.siblings('.form-messages').first();
	const $inlineError = $form.find('.campaign-entry-form__error').first();
	if (!$messages.length && !$inlineError.length) return;
	let submittedEntryUuid = '';

	function setDeviceEnteredCookie(cookieName, expiryDays) {
		const date = new Date();
		date.setTime(date.getTime() + (expiryDays * 24 * 60 * 60 * 1000));
		const expires = 'expires=' + date.toUTCString();
		document.cookie = cookieName + '=1;' + expires + ';path=/;SameSite=Strict';
	}

	function clearErrorMessage() {
		if ($inlineError.length) {
			$inlineError.removeClass('form-messages form-messages--error').text('');
		}

		if ($messages.length) {
			$messages.removeClass('form-messages--error');
		}
	}

	function showErrorMessage(message) {
		const errorText = message || '';
		const showInline = $inlineError.length && $form.is(':visible');

		if (showInline) {
			$inlineError.addClass('form-messages form-messages--error').text(errorText);
			if ($messages.length) {
				$messages.removeClass('form-messages--error');
			}
			return;
		}

		if ($messages.length) {
			$messages.addClass('form-messages--error').text(errorText);
		}
	}

	function lockFormWithMessage(message) {
		const errorText = message || '';
		$form.hide();
		$form.closest('.campaign-entry-form-wrap').addClass('is-submitted');
		if ($inlineError.length) {
			$inlineError.removeClass('form-messages form-messages--error').text('');
		}
		if ($messages.length) {
			$messages.attr('class', 'form-messages form-messages--error').text(errorText);
		}
	}

	function showRevealResult(response) {
		if (response.success) {
			const messageMarkup = response?.data?.message_html || response?.data?.message || '';
			clearErrorMessage();
			$messages.addClass('form-messages--success').html(messageMarkup);
			bindGiftCardSubmit();
			return;
		}

		showErrorMessage(response?.data?.message);
	}

	function completeRevealSuccess(response) {
		const messageMarkup = response?.data?.message_html || response?.data?.message || '';
		clearErrorMessage();
		$messages.addClass('form-messages--success').html(messageMarkup);
		bindGiftCardSubmit();

		// Set device-entered cookie after successful prize reveal
		const cookieName = response?.data?.device_cookie_name || '';
		const expiryDays = response?.data?.device_cookie_expires_days || 5;
		if (cookieName) {
			setDeviceEnteredCookie(cookieName, expiryDays);
		}
	}

	function animateTapToPrizeCircle(response) {
		if (!response?.success) {
			showErrorMessage(response?.data?.message);
			return;
		}

		const messageMarkup = response?.data?.message_html || response?.data?.message || '';
		if (messageMarkup === '') {
			completeRevealSuccess(response);
			return;
		}

		const $reveal = $messages.find('.entry-reveal').first();
		const $tapCircle = $reveal.find('.entry-reveal__button.entry-reveal__circle').first();
		if (!$reveal.length || !$tapCircle.length) {
			completeRevealSuccess(response);
			return;
		}

		const $nextMarkup = jQuery('<div>').html(messageMarkup);
		const $prizeCircle = $nextMarkup.find('.entry-reveal__circle--prize').first();
		if (!$prizeCircle.length) {
			completeRevealSuccess(response);
			return;
		}

		const reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
		if (reducedMotion) {
			completeRevealSuccess(response);
			return;
		}

		const $transitionStage = jQuery('<div class="entry-reveal__transition-stage" aria-hidden="true"></div>');
		const $tapClone = $tapCircle.clone(false)
			.removeClass('is-loading')
			.addClass('entry-reveal__transition-tap')
			.prop('disabled', true)
			.attr('tabindex', '-1');
		const $prizeClone = $prizeCircle.clone(false).addClass('entry-reveal__transition-prize');

		$transitionStage.append($tapClone, $prizeClone);
		$tapCircle.replaceWith($transitionStage);
		$reveal.addClass('entry-reveal--transitioning');

		requestAnimationFrame(function() {
			$reveal.addClass('entry-reveal--revealed');
		});

		window.setTimeout(function() {
			completeRevealSuccess(response);
		}, 820);
	}

	function bindGiftCardSubmit() {
		const $giftCardSubmitBtn = $messages.find('.win-message__gift-card-submit');
		if (!$giftCardSubmitBtn.length) {
			return;
		}

		$giftCardSubmitBtn.on('click', function() {
			const $button = jQuery(this);
			$button.prop('disabled', true).addClass('is-loading');
			clearErrorMessage();
			$messages.removeClass('form-messages--error').removeClass('form-messages--success');

			jQuery.post(site.ajaxurl, {
				action:      'reveal_gift_card_details',
				nonce:       $form.find('[name="nonce"]').val(),
				campaign_id: $form.find('[name="campaign_id"]').val(),
				lang:        site?.language || '',
				entry_uuid:  submittedEntryUuid,
			})
				.done(function(response) {
					showRevealResult(response);
				})
				.fail(function(xhr) {
					showErrorMessage(xhr?.responseJSON?.data?.message);
					$button.prop('disabled', false).removeClass('is-loading');
				});
		});
	}

	function bindRevealTap() {
		const $revealButton = $messages.find('.entry-reveal__button');
		if (!$revealButton.length) {
			return;
		}

		$revealButton.on('click', function() {
			const $button = jQuery(this);
			$button.prop('disabled', true).addClass('is-loading');
			clearErrorMessage();
			$messages.removeClass('form-messages--error').removeClass('form-messages--success');

			jQuery.post(site.ajaxurl, {
				action:      'reveal_entry_prize',
				nonce:       $form.find('[name="nonce"]').val(),
				campaign_id: $form.find('[name="campaign_id"]').val(),
				lang:        site?.language || '',
				entry_uuid:  submittedEntryUuid,
			})
				.done(function(response) {
					animateTapToPrizeCircle(response);
				})
				.fail(function(xhr) {
					showErrorMessage(xhr?.responseJSON?.data?.message);
					$button.prop('disabled', false).removeClass('is-loading');
				});
		});
	}

	$form.on('submit', function (e) {
		e.preventDefault();
		const t = (window.wp && window.wp.i18n && typeof window.wp.i18n.__ === 'function')
			? window.wp.i18n.__
			: function(value) { return value; };
		const recaptchaDisabledValue = site?.recaptcha_disabled;
		const recaptchaDisabled = recaptchaDisabledValue === true
			|| recaptchaDisabledValue === 1
			|| recaptchaDisabledValue === '1'
			|| recaptchaDisabledValue === 'true';
		const recaptchaSiteKey = site?.recaptcha_site_key || '';

		function submitEntry(recaptchaToken) {
			const $submit   = $form.find('[type="submit"]');

			clearErrorMessage();
			$messages.text('').attr('class', 'form-messages');
			$submit.prop('disabled', true);

			jQuery.post(site.ajaxurl, {
				action:        'submit_entry',
				nonce:         $form.find('[name="nonce"]').val(),
				campaign_id:   $form.find('[name="campaign_id"]').val(),
				lang:          site?.language || '',
				email_address: $form.find('[name="email_address"]').val(),
				first_name:    $form.find('[name="first_name"]').val(),
				last_name:     $form.find('[name="last_name"]').val(),
				opt_in:        $form.find('[name="opt_in"]').is(':checked') ? '1' : '0',
				marketing_opt_in: $form.find('[name="marketing_opt_in"]').is(':checked') ? '1' : '0',
				math_answer:   $form.find('[name="math_answer"]').val(),
				math_problem_token: $form.find('[name="math_problem_token"]').val(),
				website:       $form.find('[name="website"]').val(),
				recaptcha_token: recaptchaToken
			})
				.done(function(response) {
					if (response.success) {
						submittedEntryUuid = response?.data?.entry_uuid || '';
						$form.closest('.campaign-entry-form-wrap').addClass('is-submitted');
						$form.hide();
						const tapMarkup = response?.data?.tap_html || response?.data?.message || '';
						$messages.html(tapMarkup);
						bindRevealTap();
					} else {
						if (response?.data?.lock_form) {
							lockFormWithMessage(response?.data?.message);
							return;
						}
						showErrorMessage(response?.data?.message);
						$submit.prop('disabled', false);
					}
				})
				.fail(function(xhr) {
					if (xhr?.responseJSON?.data?.lock_form) {
						lockFormWithMessage(xhr?.responseJSON?.data?.message);
						return;
					}
					showErrorMessage(xhr?.responseJSON?.data?.message);
					$submit.prop('disabled', false);
				});
		}

		const $requiredOptIn = $form.find('[name="opt_in"][required]');
		if ($requiredOptIn.length && !$requiredOptIn.is(':checked')) {
			showErrorMessage($requiredOptIn.data('requiredMessage'));
			return;
		}

		if (recaptchaDisabled) {
			submitEntry('');
			return;
		}

		if (typeof grecaptcha === 'undefined' || recaptchaSiteKey === '') {
			showErrorMessage(t('Security verification failed. Please try again.', site.i18nSlug));
			return;
		}

		grecaptcha.ready(async () => {
			let token = '';
			try {
				token = await grecaptcha.execute(recaptchaSiteKey, { action: 'submit_entry' });
			} catch (error) {
				showErrorMessage(t('Security verification failed. Please try again.', site.i18nSlug));
				return;
			}

			submitEntry(token);
		});
	});
}
